import React,{Fragment} from 'react';
import Divider from 'components/Divider';

export default function ControlSeparator(props) {
    const {children,noLine} =  props;
    //判断再显示的情况如：[dom1,dom2,false];children还会有false，需要过滤
    const renderChildren = children.filter(item=>{
        return item;
    });
    const newOperation = renderChildren.map((item,index)=>{
        return(
            <Fragment key={index}>
                <div>{item}</div>
                {renderChildren.length-1 !== index && <Divider noLine={noLine}/>}
            </Fragment>
        );
    });
    return (
        <div style={{display:'flex',alignItems:'center'}}>
            {newOperation}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/ControlSeparator/index.js